import { AfterViewInit, Component, HostListener, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { first } from 'rxjs';
import { ComponentCanDeactivate } from '@app/core/guards';
import { DialogService } from '@app/core/services';
import { ApprovalTypeEnum } from '@app/enums';
import { TitleComponent } from '@app/shared/components/title/title.component';
import { ApprovalLevelComponent } from './approval-level/approval-level.component';

@Component({
	selector: 'ss-approval-setup',
	templateUrl: './approval-setup.component.html',
	standalone: true,
	imports: [TitleComponent, MatTabsModule, ApprovalLevelComponent],
})
export class ApprovalSetupComponent implements AfterViewInit, ComponentCanDeactivate {
	@ViewChild(MatTabGroup) tabs: MatTabGroup;
	@ViewChild('poapproval') poapproval: ApprovalLevelComponent;
	@ViewChild('invoiceapproval') invoiceapproval: ApprovalLevelComponent;

	@HostListener('window:beforeunload')
	canDeactivate = (): boolean => this.poapproval.CanDeactivate() && this.invoiceapproval.CanDeactivate();

	poApprovalType = ApprovalTypeEnum.PORequisition;
	invoiceApprovalType = ApprovalTypeEnum.Invoice;

	constructor(private readonly dialogService: DialogService) {}

	ngAfterViewInit(): void {
		// eslint-disable-next-line no-underscore-dangle
		const handleTabClick = this.tabs._handleClick;

		// eslint-disable-next-line no-underscore-dangle
		this.tabs._handleClick = (tab, header, index) => {
			if (this.tabs.selectedIndex === index) {
				return;
			}

			if (this.canDeactivate()) {
				handleTabClick.apply(this.tabs, [tab, header, index]);
			} else {
				this.dialogService
					.confirmUnsavedChanges()
					.pipe(first())
					.subscribe((closed) => {
						if (closed) {
							this.poapproval.reset();
							this.invoiceapproval.reset();
							handleTabClick.apply(this.tabs, [tab, header, index]);
						}
					});
			}
		};
	}
}
